// Breakpoints matching Flutter Responsive widget
export const breakpoints = {
  values: {
    xs: 0, // Mobile start
    sm: 475, // Mobile max (Flutter mobileWidth)
    md: 768, // Tablet start (Flutter tabletWidth)
    lg: 1386, // Desktop start (Flutter desktopWidth)
    xl: 1536, // Large desktop
  },
} as const;

// Breakpoint helper functions
export const isMobile = (width: number): boolean => width < breakpoints.values.md;
export const isTablet = (width: number): boolean =>
  width >= breakpoints.values.md && width < breakpoints.values.lg;
export const isDesktop = (width: number): boolean => width >= breakpoints.values.lg;

// Get current responsive size
export type ResponsiveSize = 'mobile' | 'tablet' | 'desktop';

export const getResponsiveSize = (width: number): ResponsiveSize => {
  if (width < breakpoints.values.md) return 'mobile';
  if (width < breakpoints.values.lg) return 'tablet';
  return 'desktop';
};
